import { Image } from 'expo-image';
import { Href, router } from 'expo-router';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { Badge } from 'react-native-paper';

import { smartFormatDate } from '@/utils/dateFormats';

import Text from '../Text';
import { safeJsonParse } from '@/utils/jsonParse';
import { RoomData } from '@/api/models/chatRoomModels';

export interface NotificationItemProps {
  image: string;
  title: string;
  message: string;
  date?: string;
  readed: boolean;
  path?: string;
  roomData?: string;
}

const NotificationItem = ({ image, title, message, date, readed, path, roomData }: NotificationItemProps) => {
  const styles = useStyle(readed);

  return (
    <TouchableOpacity
      disabled={path === undefined || path === null}
      onPress={() => {
        if (path && path !== null) {
          if (path.includes('messages') && roomData && roomData !== null && roomData !== 'null') {
            const roomJson = safeJsonParse<RoomData>(roomData);

            if (roomJson?.id) {
              router.prefetch({
                pathname: '/messages',
                params: {
                  roomId: roomJson?.id
                }
              });
            }
          } else if (path.includes('messages')) {
            router.navigate('/(app)/messages/');
          } else {
            router.navigate(path as Href);
          }
        }
      }}>
      <View style={styles.container}>
        {!readed && <Badge style={styles.badge} size={12} />}
        <Image source={image} style={styles.image} />

        <View style={styles.textContainer}>
          <Text fontWeight="700" style={styles.title} numberOfLines={1}>
            {title}
          </Text>
          <Text style={styles.message} numberOfLines={2}>
            {message}
          </Text>
        </View>

        {date && <Text style={styles.dateTimeText}>{smartFormatDate(date)}</Text>}
      </View>
    </TouchableOpacity>
  );
};

export default NotificationItem;

const useStyle = (readed: boolean) => {
  const readedColor = readed ? '#00000099' : 'black';

  const styles = StyleSheet.create({
    textContainer: {
      flex: 1,
      marginEnd: 12
    },

    container: {
      backgroundColor: 'white',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      columnGap: 10
    },

    image: {
      height: 42,
      width: 42,
      borderRadius: 99
    },

    title: {
      color: readedColor,
      fontSize: 16,
      flex: 1
    },

    message: {
      color: readedColor,
      flexWrap: 'wrap',
      fontSize: 14,
      flex: 1
    },

    dateTimeText: {
      color: readedColor,
      position: 'absolute',
      top: 0,
      right: 0,
      flex: 1,
      fontSize: 12
    },

    badge: {
      position: 'absolute',
      bottom: 0,
      right: 0
    }
  });

  return styles;
};
